module.exports = __webpack_public_path__ + "img/WoSindDieBären.eb0f054c.jpg";